import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(null);
  const [refreshToken, setRefreshToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored auth data
    const storedToken = localStorage.getItem('carvalho_token');
    const storedRefreshToken = localStorage.getItem('carvalho_refresh_token');
    const storedAdmin = localStorage.getItem('carvalho_admin');
    
    if (storedToken && storedAdmin) {
      setToken(storedToken);
      setRefreshToken(storedRefreshToken);
      setAdmin(JSON.parse(storedAdmin));
    }
    setLoading(false);
  }, []);

  const login = (accessToken, newRefreshToken, adminData) => {
    localStorage.setItem('carvalho_token', accessToken);
    localStorage.setItem('carvalho_refresh_token', newRefreshToken);
    localStorage.setItem('carvalho_admin', JSON.stringify(adminData));
    setToken(accessToken);
    setRefreshToken(newRefreshToken);
    setAdmin(adminData);
  };

  const logout = () => {
    localStorage.removeItem('carvalho_token');
    localStorage.removeItem('carvalho_refresh_token');
    localStorage.removeItem('carvalho_admin');
    setToken(null);
    setRefreshToken(null);
    setAdmin(null);
  };

  const isAuthenticated = () => {
    return !!token && !!admin;
  };

  const updateToken = (newAccessToken, newRefreshToken) => {
    localStorage.setItem('carvalho_token', newAccessToken);
    localStorage.setItem('carvalho_refresh_token', newRefreshToken);
    setToken(newAccessToken);
    setRefreshToken(newRefreshToken);
  };

  return (
    <AuthContext.Provider value={{
      admin,
      token,
      refreshToken,
      loading,
      login,
      logout,
      isAuthenticated,
      updateToken
    }}>
      {children}
    </AuthContext.Provider>
  );
};
